/* eslint-disable */
import React, { useEffect, useState,useContext } from 'react';
import MagnifyingGlass from '../../../Assets/images/svg/dar_magnifying.svg';
import styles from './staffingCost.module.scss';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import { TextField } from '@mui/material';
import EditIcon from '../../../Assets/images/svg/dar_pencil.svg';
import {
  EMPLOYEE_COST,
  EMPLOYEE_COST_FIELD,
  EMPLOYEE_COST_HEADER,
  VENDOR_COST,
  VENDOR_COST_FIELD,
  VENDOR_COST_HEADER,
  SAVE_SUCCESS,
  UPDATE_SUCCESS,
  OOPS_TRY_AGAIN

} from '../../../Constants/strings';
import ButtonComponent from '../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import {formatCurrency} from '../costMasterUtils';
import { getStaffingCostOption,getStaffingCostDetails,createStaffingCost,updateStaffingCost } from '../../../Api/request/costMaster';
import UseAxios from '../../../Api/http/http';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import { v4 as uuidv4 } from 'uuid';

const TableView = () => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [employeeCostGrid, setEmployeeCostGrid] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [vendorCostGrid, setVendorCostGrid] = useState([]);
  const [employeeCostOriginal, setEmployeeCostOriginal] = useState([]);
  const [vendorCostOriginal, setVendorCostOriginal] = useState([]);
  const { snackbarOpen } = useSnackbar();
const [businessVerticals, setBusinessVerticals] = useState([]);
const [roles, setRoles] = useState([]);
const [currencies, setCurrencies] = useState([]);
const { userProfile } = useContext(AuthContext);

const permission = userProfile?.permissions?.[MODULE_NAMES.MASTER_COST_MASTER] ?? [];


  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const locationOptions = [
    { id: 1, name: "Offsite" },
    { id: 2, name: "Onsite" }
  ];

  const experienceOptions = [
    { id: 1, name: "Junior" },
    { id: 2, name: "Mid" },
    { id: 3, name: "Senior" }
  ];

  useEffect(() => {
    checkMobileView();
    fetchStaffingCostOptions();
    fetchStaffingCostDetails();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const fetchStaffingCostOptions = async () => {
    try {
      const response = await UseAxios(getStaffingCostOption());
      const { vertical, role, currency } = response.data.data; 
      const roleData = role.map((role) => ({ ...role, id: role.type_id, name:role.resource_type}));

      setBusinessVerticals(vertical || []);  
      setRoles(roleData || []);                   
      setCurrencies(currency || []);        
  
    } catch (error) {
      console.error('Error fetching staffing cost options:', error.message || error);
    }
  };

  const fetchStaffingCostDetails = async () => {
    try {
      const response = await UseAxios(getStaffingCostDetails());
      const staffingCostData = response.data?.data?.data || [];
      const employeeCostData = staffingCostData
        .filter(item => item.vertical !== null) 
        .map((item, index) => ({
          id: item.id,
          srNo: index + 1,
          businessVertical: item.vertical,
          role: item.role,
          experience: item.experience.charAt(0).toUpperCase() + item.experience.slice(1).toLowerCase(),
          location: item.location.charAt(0).toUpperCase() + item.location.slice(1).toLowerCase(),
          perDayCost: item.price,
          currency: item.currency,
         isEditing: false,
        }));
  
      const vendorCostData = staffingCostData
        .filter(item => item.vertical === null) 
        .map((item, index) => ({
          id: item.id,
          srNo: index + 1,
          businessVertical: "Vendor",
          role: item.role,
          experience: item.experience.charAt(0).toUpperCase() + item.experience.slice(1).toLowerCase(),
          location: item.location.charAt(0).toUpperCase() + item.location.slice(1).toLowerCase(),
          perDayCost: item.price,
          currency: item.currency,
          isEditing: false,
        }));
  
    
      setEmployeeCostGrid(employeeCostData);
      setVendorCostGrid(vendorCostData);
    } catch (error) {
      console.error("Error fetching staffing cost details:", error.message || error);
    }
  };
  

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  function filterGrid(grid, searchText) {
    return searchText
      ? grid.filter((row) =>
          Object.values(row).some((value) =>
            (value ? value.toString() : '').toLowerCase().includes(searchText)
          )
        )
      : grid;
  }

  const filteredRowsGrid1 = filterGrid(employeeCostGrid, searchText);
  const filteredRowsGrid2 = filterGrid(vendorCostGrid, searchText);

  const handleInputChange = (e, id, field, gridName) => {
    const value = e.target.value?.name || e.target.value;
  
    if (gridName === 'employeeCostGrid') {
      setEmployeeCostGrid((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, [field]: field === "currency" ? value : value || "" } : row // Ensure currency is a string
        )
      );
    } else if (gridName === 'vendorCostGrid') {
      setVendorCostGrid((prevRows) =>
        prevRows.map((row) =>
          row.id === id ? { ...row, [field]: field === "currency" ? value : value || "" } : row // Ensure currency is a string
        )
      );
    }
  };

  const handleApiResponseError = (response) => {
    const apiMessage = response?.data?.response?.data?.message;
    
    if (apiMessage?.toLowerCase().includes("record already exists")) {
      snackbarOpen(apiMessage, "error");
    } else {
      snackbarOpen(OOPS_TRY_AGAIN, "error");
    }
  
  };
  
const saveRow = async (rowToSave, gridType, operationType) => {
  const id = rowToSave.id;

  const payload = {
    vertical: gridType === 'employee'
 ? getFieldIdValue("businessVertical", rowToSave.businessVertical, businessVerticals)
 : null,    role: getFieldIdValue("role", rowToSave.role, roles),
    experience: rowToSave.experience,
    location: rowToSave.location,
    price: rowToSave.perDayCost,
    currency: getFieldIdValue("currency", rowToSave.currency, currencies),
  };

  try {
    let response;
    if (operationType === "insert") {
      response = await UseAxios(createStaffingCost(payload));
    } else if (operationType === "update" && id) {
        response = await UseAxios(updateStaffingCost({ ...payload, id }));
    } else {
      throw new Error("Invalid operation type or missing ID");
    }

      const responseData = response?.data?.data;
      if (!responseData) {
        handleApiResponseError(response);
        return; }
    const updateGrid = (setGrid) => {
        setGrid((prevRows) =>
          prevRows.map((row) =>
            row.id === rowToSave.id
              ? { ...row, currency: rowToSave.currency, isEditing: false, error: false }
              : row
          )
        );
      };

      gridType === "employee" ? updateGrid(setEmployeeCostGrid) : updateGrid(setVendorCostGrid);
   snackbarOpen(operationType === "insert" ? SAVE_SUCCESS : UPDATE_SUCCESS, "success");
      fetchStaffingCostDetails();
    } catch (error) {
      console.error('Error updating row:', error.message || error);
      snackbarOpen(OOPS_TRY_AGAIN, "error");
    }
  };



  

  
  


  

const handleEditGrid = (id, gridType) => {
  if (gridType === 'employee') {
    setEmployeeCostOriginal((prev) => ({
      ...prev,
      [id]: { ...employeeCostGrid.find(row => row.id === id) }, 
    }));

    setEmployeeCostGrid((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: true } : row
      )
    );
  } else if (gridType === 'vendor') {
    setVendorCostOriginal((prev) => ({
      ...prev,
      [id]: { ...vendorCostGrid.find(row => row.id === id) },
    }));

    setVendorCostGrid((prevRows) =>
      prevRows.map((row) =>
        row.id === id ? { ...row, isEditing: true } : row
      )
    );
  }
};



const handleAddRowGrid1 = () => {
  const newRow = {
    id: uuidv4(),
    srNo: employeeCostGrid.length + 1, 
    businessVertical: '',
    role: '',
    experience: '',
    location: '',
    perDayCost: '',
    currency: 'INR',  // Set default to INR
    isEditing: true,
    operationType: 'insert', 
  };

  const updatedEmployeeRow = [newRow, ...employeeCostGrid].map((row, index) => ({
    ...row,
    srNo: index + 1,
  }));
  setEmployeeCostGrid(updatedEmployeeRow);
};

const handleAddRowGrid2 = () => {
  const newRow = {
    id: uuidv4(),
    srNo: vendorCostGrid.length + 1, 
    businessVertical: "Vendor",
    role: '',
    experience: '',
    location: '',
    perDayCost: '',
    currency: 'INR', 
    isEditing: true,
    operationType: 'insert', 
  };

  const updatedVendorRow = [newRow, ...vendorCostGrid].map((row, index) => ({
    ...row,
    srNo: index + 1,
  }));
  setVendorCostGrid(updatedVendorRow);
};
    
    

    const handleCancel = (id, gridType) => {
      if (gridType === 'employee') {
        setEmployeeCostGrid((prevRows) => {
          const updatedRows = prevRows.some((row) => row.id === id && !employeeCostOriginal[id])
            ? prevRows.filter((row) => row.id !== id) 
            : prevRows.map((row) =>
                row.id === id
                  ? { ...(employeeCostOriginal[id] || row), isEditing: false } 
                  : row
              );
    
          // Rearrange srNo
          return updatedRows.map((row, index) => ({
            ...row,
            srNo: index + 1,
          }));
        });
    
        setEmployeeCostOriginal((prev) => {
          const newData = { ...prev };
          delete newData[id]; // Clean up stored original row
          return newData;
        });
      } else if (gridType === 'vendor') {
        setVendorCostGrid((prevRows) => {
          const updatedRows = prevRows.some((row) => row.id === id && !vendorCostOriginal[id])
            ? prevRows.filter((row) => row.id !== id) 
            : prevRows.map((row) =>
                row.id === id
                  ? { ...(vendorCostOriginal[id] || row), isEditing: false } 
                  : row
              );
    
          return updatedRows.map((vendorRow, index) => ({
            ...vendorRow,
            srNo: index + 1,
          }));
        });
    
        setVendorCostOriginal((prev) => {
          const newData = { ...prev };
          delete newData[id]; 
          return newData;
        });
      }
    };
    
  const newEmployeeRowTemplate = {
    businessVertical: '',
    role: '',
    experience: '',
    location: '',
    perDayCost: '',
  };

  const newVendorRowTemplate = {
    role: '',
    experience: '',
    location: '',
    perDayCost: '',
  };

  const isRowUnchanged = (row, template) => {
    return Object.keys(template).some((key) => row[key] === template[key]);
  };

  const getSelectedValue = (name, options) => {
     return options.find(option => option.name === name) || null;
  };    

  const columns = [
    {
      field: EMPLOYEE_COST_FIELD.SR_NO,
      headerName: EMPLOYEE_COST_HEADER.SR_NO,
      width: 110,
      flex: !isMobileView ? 0.08 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: EMPLOYEE_COST_FIELD.BUSINESS_VERTICAL,
      headerName: EMPLOYEE_COST_HEADER.BUSINESS_VERTICAL,
      width: 170,
      flex: !isMobileView ? 0.12 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={businessVerticals}
              onChange={(e) => handleInputChange(e, row.id, 'businessVertical', 'employeeCostGrid')}
              value={getSelectedValue(row.businessVertical, businessVerticals)}
              dropdownCss={styles['text-box-css']}
            />
          </div>
        ) : (
          <label className="saved-value">{row.businessVertical}</label>
        ),
    },
    
    {
      field: EMPLOYEE_COST_FIELD.ROLE,
      headerName: EMPLOYEE_COST_HEADER.ROLE,
      width: 180,
      flex: !isMobileView ? 0.14 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              placeholder='Select'
              options={roles}
              onChange={(e) => handleInputChange(e, row.id, 'role', 'employeeCostGrid')}
              value={getSelectedValue(row.role, roles)}
              dropdownCss={styles['text-box-css']}
            />            
          </div>
        ) : (
          <label className="saved-value">{row.role}</label>
        ),
    },
    {
      field: EMPLOYEE_COST_FIELD.EXPERIENCE,
      headerName: EMPLOYEE_COST_HEADER.EXPERIENCE,
      width: 150,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={experienceOptions}
              onChange={(e) => handleInputChange(e, row.id, 'experience', 'employeeCostGrid')}
              value={getSelectedValue(row.experience, experienceOptions)}
              dropdownCss={styles['text-box-css']}
            />   
          </div>
        ) : (
          <label className="saved-value">{row.experience}</label>
        ),
    },
    {
      field: EMPLOYEE_COST_FIELD.LOCATION,
      headerName: EMPLOYEE_COST_HEADER.LOCATION,
      width: 150,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={locationOptions}
              onChange={(e) => handleInputChange(e, row.id, 'location', 'employeeCostGrid')}
              value={getSelectedValue(row.location, locationOptions)}
              dropdownCss={styles['text-box-css']}
            />
          </div>
        ) : (
          <label className="saved-value">{row.location}</label>
        ),
    },
    {
      field: EMPLOYEE_COST_FIELD.PER_DAY_COST,
      headerName: EMPLOYEE_COST_HEADER.PER_DAY_COST,
      width: 160,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: styles["staffing-header"],
      renderCell: ({ row }) => {
        // Ensure the currency is a valid string
        const currencyCode = typeof row.currency === "string" ? row.currency : "INR";
    
        return row.isEditing ? (
          <div style={{ display: 'flex', alignItems: 'center' }} className={styles['number-input-div']}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={currencies}
              onChange={(e) => handleInputChange(e, row.id, 'currency', 'employeeCostGrid')}
              value={getSelectedValue(row.currency, currencies)}
              dropdownCss={styles['currency-select']}
            />
            <TextField
              defaultValue={row.perDayCost}
              onChange={(e) => handleInputChange(e, row.id, 'perDayCost', 'employeeCostGrid')}
              onKeyDown={(e) => e.stopPropagation()}
              className={styles['number-input']}
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*[.]?[0-9]*',
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                const parts = e.target.value.split('.');
                if (parts.length > 2) {
                  e.target.value = parts[0] + '.' + parts.slice(1).join('');
                }
              }}
            />
          </div>
        ) : (
          <label className={styles["staffing-cell"]}>
            {formatCurrency(row.perDayCost, currencyCode)} 
          </label>
        );
      }
    }  
    
  ];

  const columns1 = [
    {
      field: VENDOR_COST_FIELD.SR_NO,
      headerName: VENDOR_COST_HEADER.SR_NO,
      width: 110,
      flex: !isMobileView ? 0.08 : undefined,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: VENDOR_COST_FIELD.Role,
      headerName: VENDOR_COST_HEADER.Role,
      width: 170,
      flex: !isMobileView ? 0.16 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              placeholder='Select'
              options={roles}
              onChange={(e) => handleInputChange(e, row.id, 'role', 'vendorCostGrid')}
              value={getSelectedValue(row.role, roles)}
              dropdownCss={styles['text-box-css']}
            />
          </div>
        ) : (
          <label className="saved-value">{row.role}</label>
        ),
    },
    {
      field: VENDOR_COST_FIELD.EXPERIENCE,
      headerName: VENDOR_COST_HEADER.EXPERIENCE,
      width: 150,
      flex: !isMobileView ? 0.12 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={experienceOptions}
              onChange={(e) => handleInputChange(e, row.id, 'experience', 'vendorCostGrid')}
              value={getSelectedValue(row.experience, experienceOptions)}
              dropdownCss={styles['text-box-css']}
            />
          </div>
        ) : (
          <label className="saved-value">{row.experience}</label>
        ),
    },

    {
      field: VENDOR_COST_FIELD.LOCATION,
      headerName: VENDOR_COST_HEADER.LOCATION,
      width: 150,
      flex: !isMobileView ? 0.12 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={locationOptions}
              onChange={(e) => handleInputChange(e, row.id, 'location', 'vendorCostGrid')}
              value={getSelectedValue(row.location, locationOptions)}
              dropdownCss={styles['text-box-css']}
            />
          </div>
        ) : (
          <label className="saved-value">{row.location}</label>
        ),
    },
    {
      field: VENDOR_COST_FIELD.PER_DAY_PRICE,
      headerName: VENDOR_COST_HEADER.PER_DAY_PRICE,
      width: 160,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: styles["staffingCost-header"],
      renderCell: ({ row }) => {
        const currencyCode = typeof row.currency === "string" ? row.currency : "INR"; 
    
        return row.isEditing ? (
          <div style={{ display: 'flex', alignItems: 'center' }} className={styles['number-input-div']}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={currencies}
              onChange={(e) => handleInputChange(e, row.id, 'currency', 'vendorCostGrid')}
              value={getSelectedValue(row.currency, currencies)}
              dropdownCss={styles['currency-select']}
            />
            <TextField
              defaultValue={row.perDayCost}
              onChange={(e) => handleInputChange(e, row.id, 'perDayCost', 'vendorCostGrid')}
              onKeyDown={(e) => e.stopPropagation()}
              className={styles['number-input']}
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*[.]?[0-9]*',
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                const parts = e.target.value.split('.');
                if (parts.length > 2) {
                  e.target.value = parts[0] + '.' + parts.slice(1).join('');
                }
              }}
            />
          </div>
        ) : (
          <label className={styles["staffingCost-cell"]}>
            {formatCurrency(row.perDayCost, currencyCode)}
          </label>
        );
      }
    }
  ];
  const handleSave = (id, gridType) => {
   
  
    if (!gridType) {
        console.error("Error: gridType is undefined when calling handleSave!");
        return;
    }
  
    const rowToSave = gridType === 'employee' 
      ? employeeCostGrid.find((row) => row.id === id) 
      : vendorCostGrid.find((row) => row.id === id);
  
    if (!rowToSave) {
        console.error(`Row with ID ${id} not found in ${gridType} grid.`);
        snackbarOpen(OOPS_TRY_AGAIN, "error");
        return;
    }
  
    saveRow(rowToSave, gridType, rowToSave.operationType || 'update');
  };
  


  
  
  
  
  const employeeColumns = [
    ...columns,
    {
      headerClassName: !isMobileView
        ? ''
        : `${styles['action-column']} ${styles['tableView-action-cellWidth']}`,
      cellClassName: !isMobileView
        ? ''
        : `${styles['action-cell']} ${styles['tableView-action-cellWidth']}`,
      flex: 0.02,
      minWidth: 75,
      renderCell: ({ row }) => (
        <div style={{ marginTop: row.isEditing ? '4px' : '0px', justifySelf:'center',justifyContent:'center !important'}}>
          {!row?.isEditing ? (
            <button
              aria-label="Edit"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
                opacity: !hasAccess('update') ? 0.5 : 1,
              }}
              disabled={!hasAccess('update')}
              onClick={() => handleEditGrid(row.id, 'employee')}
            >
              <img src={EditIcon} alt="Edit" />
            </button>
          ) : (
            <div className={styles['save-and-cancel-button-main']} style={{ paddingTop: '0px' }}>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-tick-placing']}
                style={{
                  backgroundColor: isRowUnchanged(row, newEmployeeRowTemplate) ? '#a69df1' : '#6B5CE8',
                  color: '#ffff',
                }}
                onClick={() => handleSave(row.id, 'employee')}
                disabled={isRowUnchanged(row, newEmployeeRowTemplate)}
              >✔</button>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-cross-placing']}
                style={{
                  backgroundColor: 'transparent',
                  color: '#6B5CE8',
                  border: '1px solid #6B5CE8'
                }}
                onClick={() => handleCancel(row.id, 'employee')}
              >X</button>
            </div>
          )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    }
  ];

  const vendorColumns = [
    ...columns1,
    {
      headerClassName: !isMobileView
        ? ''
        : `${styles['action-column']} ${styles['tableView-action-cellWidth']}`,
      cellClassName: !isMobileView
        ? ''
        : `${styles['action-cell']} ${styles['tableView-action-cellWidth']}`,
      flex: 0.02,
      minWidth: 75,
      renderCell: ({ row }) => (
        <div style={{ marginTop: row.isEditing ? '4px' : '0px', justifySelf:'center'}}>
       {!row?.isEditing ? (
            <button
              aria-label="Edit"
              style={{
                background: 'none',
                border: 'none',
                padding: 0,
                cursor: !hasAccess('update') ? 'not-allowed' : 'pointer',
                opacity: !hasAccess('update') ? 0.5 : 1,
              }}
              disabled={!hasAccess('update')}
              onClick={() => handleEditGrid(row.id, 'vendor')}
            >
              <img src={EditIcon} alt="Edit" />
            </button>
          ) : (
            <div className={styles['save-and-cancel-button-main']} style={{ paddingTop: '0px' }}>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-tick-placing']}
                style={{
                  backgroundColor: '#6B5CE8',
                  color: '#ffff',
                }}
                onClick={() => handleSave(row.id, 'vendor')}
                disabled={isRowUnchanged(row, newVendorRowTemplate)}
              >✔</button>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-cross-placing']}
                style={{
                  backgroundColor: 'transparent',
                  color: '#6B5CE8',
                  border: '1px solid #6B5CE8'
                }}
                onClick={() => handleCancel(row.id, 'vendor')}
              >X</button>
            </div>
          )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const sortFilterColumns1 = [
    employeeColumns[0].field,
    employeeColumns[1].field,
    employeeColumns[2].field,
    employeeColumns[3].field,
    employeeColumns[4].field,
    employeeColumns[5].field,
  ];

  const sortFilterColumns2 = [
    vendorColumns[0].field,
    vendorColumns[1].field,
    vendorColumns[2].field,
    vendorColumns[3].field,
    vendorColumns[4].field,
  ];

  const rowHeightCondition = (params) => {
    const employeeRow = employeeCostGrid.find((row) => row.id === params.id);
    if (employeeRow?.isEditing) {
      return 104;
    }

    const vendorRow = vendorCostGrid.find((row) => row.id === params.id);
    if (vendorRow?.isEditing) {
      return 104;
    }

    return 52;
  };

  const getFieldIdValue = (field, value, list) => {
    if (field === 'currency') {
      return list.find(item => item.name === value)?.id || null; // Convert currency name to ID for API
    }
    if (field === 'role') {
      return list.find(item => item.resource_type === value)?.type_id || null;
    }
    return list.find(item => item.name === value)?.id || null;
  };
  
  
  

  return (
    <div className="users-manage-outer-layer">
      <div className="users-manage">
        <div
          className={`${styles['tableView-search-and-buttons']} ${styles['tableView-headerSection-flex']} ${styles['filteredRows-tableView']} ${styles['tableView-margin']}`}
          style={{ padding: '8px 12px' }}
        >
          <div className={styles['tableView-headerSection-main']}>
            <div
              className={`${styles['tableView-search']} ${styles['tableView-headerSection-mainSearchInput']}`}
            >
              <div className={styles['tableView-headerSection-search']}>
                <img src={MagnifyingGlass} alt="Search" />
                <input
                  id="tableView-search-input"
                  type="text"
                  placeholder="Search..."
                  onChange={handleSearch}
                  className={styles['tableView-headerSection-searchInput']}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles['tableView-data-grid-container']} ${styles['filteredRows-tableView']}}`}
        >
          <div className={styles['cost-title-container']}>
            <div className={styles['staffing-cost-button']}>
              <h2>{EMPLOYEE_COST}</h2>
              <ButtonComponent
                variant="contained"
                label="Add"
                onClick={handleAddRowGrid1}
                startIcon={<AddIcon />}
                className={styles['add-button-css']}
                disabled={!hasAccess('create')} 
              />
            </div>

            <DataGridComponent
              dataRows={filteredRowsGrid1}
              dataColumns={employeeColumns}
              isDealTransition={true}
              isFilteredRows={filteredRowsGrid1}
              sortFilterColumns={sortFilterColumns1}
              pageSize={10}
              isEdit={setEmployeeCostGrid}
              onRowSelectionChange={() => {}}
              dataGridCss=""
              checkboxDisabled={false}
              rowHeightCondition={rowHeightCondition}
            />
          </div>
        </div>

        <div
          className={`${styles['tableView-data-grid-container']} ${styles['filteredRows-tableView']}}`}
          style={{ marginTop: '20px' }}
        >
          <div className={styles['cost-title-container']}>
            <div className={styles['staffing-cost-button']}>
              <h2>{VENDOR_COST}</h2>
              <ButtonComponent
                variant="contained"
                label="Add"
                onClick={handleAddRowGrid2}
                startIcon={<AddIcon />}
                disabled={!hasAccess('create')}
                className={styles['add-button-css']}
              />
            </div>

            <DataGridComponent
              dataRows={filteredRowsGrid2}
              isDealTransition={true}
              dataColumns={vendorColumns}
              pageSize={10}
              isFilteredRows={filteredRowsGrid2}
              sortFilterColumns={sortFilterColumns2}
              isEdit={setVendorCostGrid}
              rowHeightCondition={rowHeightCondition}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableView;
